import React from 'react';
import PropTypes from 'prop-types';
import { Label, Row, Col, Button } from 'reactstrap';
import TextInput from '../controls/textInput';
import { removeItemWithConfirm } from '../classes/handleItemWithConfirm';
import { ResizedUploader as Upload } from '../controls/upload';
import Icon from '../containers/icon';
import Thumbnail from './thumbnail';
const PhotoItem = _ref => {
  let _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'no-class-name' : _ref$className,
    _ref$marginTop = _ref.marginTop,
    marginTop = _ref$marginTop === void 0 ? '0px' : _ref$marginTop,
    _ref$data = _ref.data,
    tempPath = _ref$data.tempPath,
    caption = _ref$data.caption,
    _ref$includeDivider = _ref.includeDivider,
    includeDivider = _ref$includeDivider === void 0 ? false : _ref$includeDivider,
    _ref$hasCaption = _ref.hasCaption,
    hasCaption = _ref$hasCaption === void 0 ? true : _ref$hasCaption,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    setSaveStatus = _ref.setSaveStatus,
    _ref$fluid = _ref.fluid,
    fluid = _ref$fluid === void 0 ? false : _ref$fluid,
    onUpload = _ref.onUpload,
    data = _ref.data,
    index = _ref.index,
    onChange = _ref.onChange,
    onRemove = _ref.onRemove;
  const handleChange = function handleChange(name, value) {
    let isPending = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    onChange({
      index,
      name,
      value,
      isPending
    });
  };
  const handleChangeCaption = (_, value) => {
    onChange(index, {
      name: 'caption',
      value
    });
  };
  const handleUpload = onUpload.bind(this, data, index);
  const confirmOnRemoveFields = ['caption', 'path'];
  // handleRemove = () => props.onRemove({ name: 'photo', index: props.index, isPending: true });
  const handleRemove = () => onRemove(index);
  // this calls onRemove IFF either
  //   a) there is no data to confirm removing in the item, or
  //   b) the user says it is okay to remove the all the data.
  const handleRemovePhoto = () => removeItemWithConfirm(data, 'photo', confirmOnRemoveFields, handleRemove);

  // Build the upload dropzone and button
  const uploadProps = {
    loading,
    onChange: handleChange,
    onUpload: handleUpload,
    setSaveStatus
  };

  // Thumbnail throws a console warning if you try and make a thumbnail with empty source
  const uploadOrImage = tempPath ? /*#__PURE__*/React.createElement(Thumbnail, {
    src: tempPath,
    style: {
      width: '100%',
      marginBottom: '0px'
    }
  }) : /*#__PURE__*/React.createElement(Upload, uploadProps) // eslint-disable-line react/jsx-props-no-spreading
;
  return /*#__PURE__*/React.createElement("section", {
    style: {
      marginTop
    }
  }, /*#__PURE__*/React.createElement(Row, {
    className: className
  }, /*#__PURE__*/React.createElement(Col, {
    sm: fluid ? 12 : 9,
    style: {
      marginBottom: '20px'
    },
    className: "t-pi-image"
  }, /*#__PURE__*/React.createElement(Label, null, "\xA0"), uploadOrImage), /*#__PURE__*/React.createElement(Col, {
    sm: fluid ? 12 : 3
  }, hasCaption ? /*#__PURE__*/React.createElement(TextInput, {
    type: "textarea",
    label: "Description",
    value: caption || '',
    style: {
      minHeight: '150px'
    },
    onChange: handleChangeCaption,
    className: "t-p-caption"
  }) : undefined, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    disabled: disabled,
    className: "form-control t-p-remove-photo tqc-control",
    onClick: handleRemovePhoto
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "trash"
  }), " Remove Photo"))), includeDivider ? /*#__PURE__*/React.createElement("hr", null) : undefined);
};
PhotoItem.propTypes = {
  loading: PropTypes.bool,
  data: PropTypes.shape({
    caption: PropTypes.string,
    tempPath: PropTypes.string
  }).isRequired,
  disabled: PropTypes.bool,
  fluid: PropTypes.bool,
  hasCaption: PropTypes.bool,
  includeDivider: PropTypes.bool,
  index: PropTypes.number.isRequired,
  marginTop: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onUpload: PropTypes.func.isRequired,
  setSaveStatus: PropTypes.func.isRequired,
  className: PropTypes.string
};
export default PhotoItem;